import sleepGuideMain from "@/assets/images/sleepGuide/sleepGuide.png";
import BlogContent from "../BlogContent";
import SleepGuideContent from "../SleepGuideContent";

const SLEEP_GUIDE: BlogContent = {
  id: 18,
  label: "Jūsų dovana už prenumeratą - praktinis miego gidas",
  description:
    "Šis gidas - tai unikali galimybė gauti išsamias, moksliškai pagrįstas miego rekomendacijas, parengtas gyd. Vaivos Zinkevičiūtės-Balsės, remiantis naujausiais miego medicinos tyrimais. Tai apjungtos mokslinių publikacijų analizės, klinikinė patirtis ir ekspertinės gydytojos įžvalgos.",
  descriptionInner:
    "Šis gidas - tai unikali galimybė gauti išsamias, moksliškai pagrįstas miego rekomendacijas, parengtas gyd. Vaivos Zinkevičiūtės-Balsės, remiantis naujausiais miego medicinos tyrimais. Tai apjungtos mokslinių publikacijų analizės, klinikinė patirtis ir ekspertinės gydytojos įžvalgos.",
  img_src: sleepGuideMain,
  alt: "Miego gidas cover",
  tags: ["Miegas"],
  hideMainHeader: true,
  innerData: [
    {
      id: 1,
      description: [<SleepGuideContent />],
    },
  ],
};

export default SLEEP_GUIDE;
